<template>
  <!-- 出入金明细 -->
  <div id="agentUserList">
    <!-- 头部数据更新时间模块 -->
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <!--搜索uid-->
          <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
            <b-form-input v-model.trim="searchUid" maxLength="19" placeholder=""></b-form-input>
          </b-form-group>
          <!-- 币种 -->
          <b-form-group :label="$t('common.symbol')" class="find-middle">
            <v-select class="find-select" v-model="symbol" :options="symbolList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>
          <template>
            <!-- 类型 -->
            <b-form-group :label="$t('common.type')" class="find-middle">
              <v-select class="find-select" v-model="infoType" :options="infoTypeArr">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group>
            <!-- 时间 -->
            <b-form-group :label="$t('common.date')" class="find-middle">
              <el-date-picker v-model="dateArray" unlink-panels type="datetimerange" value-format="timestamp"
                range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                @change="handleChangeDate" :clearable="false" :picker-options="pickerOptions">
              </el-date-picker>
            </b-form-group>
          </template>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                      <use xlink:href="#icon-v4_17"></use>
                    </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                      <use xlink:href="#icon-v4_3"></use>
                    </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
                class="float-left"
                v-if="pages.total > 0"
                :total-rows="pages.total"
                :perPage="pages.size"
                :pageOptions="pages.options"
                :currentPage="pages.page"
                @initialize="pageChange"
                layout="total,sizes"
              >
              </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass"
            :default-sort="{ prop: 'totalAmount', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!--  序号 -->
            <!-- <el-table-column prop="sort" align="left" :label="$t('common.sort')">
            </el-table-column> -->
            <!--  时间-->
            <el-table-column prop="ctime" align="left" :label="$t('common.date')">
            </el-table-column>
            <!--  uid-->
            <el-table-column prop="uid" align="right" :label="$t('lanV4.newUid')">
            </el-table-column>
            <!-- 类型 -->
            <el-table-column prop="type" :label="$t('common.type')" align="right">
              <template slot-scope="scope">
                     {{ scope.row.type }}
              </template>
            </el-table-column>
            <!-- 金额 -->
            <el-table-column prop="amount" :label="$t('common.money')" align="right">
            </el-table-column>
            <!-- 金币种-->
            <el-table-column prop="symbol" :label="$t('common.symbol')" align="right">
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
            $t("exportsModal.text2", { pagesTotal: pages.total, maxNum: exportNumLimit })
          }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
            $t("common.cancel")
          }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
export default {
  name: "agentUserList",
  mixins: [commonMixin],
  components: {
    headerUpdate,
  },
  data() {
    return {
      searchUid: null, // uid
      symbolList: [],
      symbol: null,
      infoType: null, //类型
      dateArray: [new Date().getTime() - 86400000 * 7, new Date().getTime()],
      beginDate: null,
      endDate: null,
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "totalAmount", //默认排序字段
      sortSet: 1, //默认倒序
    };
  },
  computed: {
    //类型
    infoTypeArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.transferToCo"), //币币到合约 
          value: 'wallet_to_contract',
        },
        {
          label: this.$t("lanV4.transferOutCo"), //合约到币币
          value: 'contract_to_wallet',
        },
      ];
    },
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
  },
  watch: {

    searchUid(v) {
      if (v) {
        this.$nextTick(() => {
          this.searchUid = fixInput(v, 0, { num: 1 });
        });
      }
    },
  },
  created() {
    this.handleChangeDate();
    this.infoType = this.infoTypeArr[0];
    this.getAgentSmbolList() //获取保证金币种
  },
  methods: {
    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },

    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
        case "fee":
          this.sortName = "fee";
          break;
        case "returnAmount":
          this.sortName = "returnAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },
    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.searchUid = null;
      this.symbol = this.symbolDefaultValue();
      this.infoType = this.infoTypeArr[0];
      this.dateArray = [
        new Date().getTime() - 86400000 * 7,
        new Date().getTime(),
      ];
      this.handleChangeDate();
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        startTime: this.dateArray ? this.beginDate : null,
        endTime: this.dateArray ? this.endDate : null,
        uid: this.searchUid,
        symbol: this.symbol ? this.symbol.value : null,
        type: this.infoType ? this.infoType.value : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        isExport: 0,
      };
      this.$http({
        url: this.$store.state.url.agent.inAndOutDetail,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, records } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (records && records.length) {
        records.map((item, index) => {
          arr.push({
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            ctime: item.startTime ? formatTime(item.startTime) : "--", //注册时间
            uid: item.uid,
            type: item.type,
            amount: item.amount,
            symbol: item.symbol
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 获取经纪人保证金币种
    getAgentSmbolList() {
      this.$http({
        url: this.$store.state.url.agent.getMarginCoinList,
        params: {
          companyId: null,
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [{ label: this.$t("common.all"), value: null }];
          if (data.coinList.length) {
            data.coinList.map((item) => {
              if (this.roleType == 0 || this.roleType == 1) {
                // 平台商户展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
              if (this.roleType == 3 || this.roleType == 4) {
                // 经纪人展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
            });
          }
          this.symbolList = arr;
          this.symbol = this.symbolDefaultValue();
          this.getData();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    //获取保证金币种默认值
    symbolDefaultValue() {
      let data = [];
      if (this.symbolList && this.symbolList.length) {
        data = this.symbolList[0];
        this.symbolList.forEach((item) => {
          if (item.value === "null") {
            data = item;
          }
        });
      }
      return data;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          startTime: this.dateArray ? this.beginDate : null,
          endTime: this.dateArray ? this.endDate : null,
          uid: this.searchUid,
          symbol: this.symbol ? this.symbol.value : null,
          type: this.infoType ? this.infoType.value : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          isExport: 1,
        };

        this.outExcel(
          this.$store.state.url.agent.inAndOutDetail,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    onReset() {
      this.exportsModalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
#agentUserList {
  .custom-control {
    top: 5px !important;
  }
}
</style>